import { render, staticRenderFns } from "./HelloComputer.vue?vue&type=template&id=fbac1716&"
import script from "./HelloComputer.vue?vue&type=script&lang=js&"
export * from "./HelloComputer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports